import React, { createContext, useContext, useCallback, useState } from 'react';

export interface ToastMessage {
  id?: string;
  type: 'info' | 'success' | 'error' | 'warning';
  title?: string;
  description: string;
}

interface ToastContextData {
  messageToast: ToastMessage;
  onSetMessage: (message : ToastMessage) => void;
  onClearMessage: () => void;
}

const ToastContext = createContext<ToastContextData>({} as ToastContextData);

const ToastProvider: React.FC = ({ children }) => {
  const [messageToast, setMessages] = useState<ToastMessage>({} as ToastMessage);

  const onSetMessage = useCallback((message : ToastMessage) => {
    setMessages(message);
  }, []);

  const onClearMessage = useCallback(() => {
    setMessages({} as ToastMessage);
  }, []);

  return (
    <ToastContext.Provider value={{ onSetMessage,  onClearMessage, messageToast}}>
      {children}
      {/* <ToastContainer /> */}
    </ToastContext.Provider>
  );
};

function useToast(): ToastContextData {
  const context = useContext(ToastContext);

  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }

  return context;
}

export { ToastProvider, useToast };
